var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticStyle: {
        display: "block",
        position: "relative",
      },
      on: {
        click: function ($event) {
          return _vm.ackNotification({
            type: _vm.toWatches,
          })
        },
      },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.notificationCount > 0
        ? _c("v-badge", {
            attrs: {
              bordered: "",
              inline: "",
              color: "red",
              content: _vm.notificationCount,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }